import { clues } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

const badgeStyle: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-900",
  secondary: "bg-secondary-200 text-secondary-900",
};
const dotStyle: Record<string, string> = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-400",
};

export default function ClueBoard() {
  return (
    <section id="clues" className="scroll-mt-16 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          index="05"
          eyebrow="Clues"
          title="独家线索"
          desc="编辑部开放更新的线索公告板。每条线索都标注可信度与跟进状态——有方向就如实写，没定论就如实标。"
        />

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {clues.map((c) => (
            <article
              key={c.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5"
            >
              <div className="flex items-center justify-between">
                <span className={`rounded-md px-2 py-1 text-xs font-bold ${badgeStyle[c.color]}`}>
                  {c.levelName}
                </span>
                <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <span className={`h-1.5 w-1.5 rounded-full ${dotStyle[c.color]}`} />
                  {c.status}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold leading-snug text-foreground-950">
                {c.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              <a
                href="#subscribe"
                className="mt-4 inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600 hover:text-primary-700"
              >
                补充这条线索
                <i className="ri-arrow-right-line" />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}